import React from 'react';
import PropTypes from 'prop-types';

const NoPackagesBanner = ({ message }) => {
	return (
		<div className="no-package-item bg-contrast-med mt-7 p-5 ddc-font-size-small">
			<i className="ddc-icon ddc-icon-info mr-3" aria-hidden="true" />
			<span>{message}</span>
		</div>
	);
};

NoPackagesBanner.propTypes = {
	message: PropTypes.string.isRequired
};

export default NoPackagesBanner;
